/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @time 18/11/2023
 */

import React, { useContext, useEffect, useRef } from 'react'
import CheckoutContext from '../../Context/CheckoutContext';
import { SET_TIME } from '../../Pages/CheckoutPage';
import styles from "./TimeSelect.module.css"
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation } from "swiper";
import { isMobile } from 'react-device-detect';
import { useGetAllSlotsQuery } from '../../Store/Services/SlotService';
import { Backdrop, CircularProgress } from '@mui/material';

const TimeSelect = () => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);
    const timePrevRef = useRef(null);
    const timeNextRef = useRef(null);

    const { data: slots, isSuccess, isLoading } = useGetAllSlotsQuery();

    useEffect(() => {
        if (isSuccess && !isLoading) {
            dispatch({ type: SET_TIME, payload: {
                timeSlotId: slots[0].slotId,
                timeSlot: slots[0].slot,
            }})
        }
    }, [slots])

    const onTimeSelect = (id, value) => {
        dispatch({ type: SET_TIME, payload: {
            timeSlotId: id,
            timeSlot: value,
        }})
    }

    return (
        <div className={styles.selectionContainer}>
            {isLoading && (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <Swiper
                slidesPerView={isMobile ? 1.5 : 3}
                spaceBetween={10}
                slidesPerGroup={isMobile ? 1 : 3}
                freeMode={true}
                modules={[Navigation]}
                className={styles['sample-slider']}
                navigation={{
                    prevEl: timePrevRef.current,
                    nextEl: timeNextRef.current,
                }}
            >
                {isSuccess && slots.map(slot => (
                    <SwiperSlide
                        key={slot.slotId}
                        className={`${styles.timeButton} ${checkoutData.timeSlotId == slot.slotId && styles.timeButtonSelected}`}
                        onClick={() => onTimeSelect(slot.slotId, slot.slot)}
                    >
                        {slot.slot}
                    </SwiperSlide>
                ))}
            </Swiper>
            <div ref={timePrevRef} className="swiper-button-prev"></div>
            <div ref={timeNextRef} className="swiper-button-next"></div>
        </div>
    )
}

export default TimeSelect